<template>
  <div>
    <RoutingPlanTabHeader
      v-model="filters.name.value"
      :is-refreshing="vm.isRefreshingTargets"
      @refresh="vm.refreshTargets"
      @create-new="vm.openNewTargetModal"
    />

    <div
      v-if="displayTargets.length"
      class="grid_table_holder p-10"
    >
      <v-table
        :data="displayTargets"
        :current-page.sync="currentPage"
        :page-size="10"
        :filters="filters"
        :hide-sort-icons="true"
        class="table_beauty table-condensed"
        cellpadding="0"
        cellspacing="0"
        @totalPagesChanged="totalPages = $event"
      >
        <thead slot="head">
          <tr>
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_TARGETS_NAME'"
              class="column-sortable width-30-percent"
              align="left"
              sort-key="name"
              default-sort="asc"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_TARGETS_TYPE'"
              sort-key="type"
              class="column-sortable"
              align="center"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_TARGETS_NUMBER'"
              sort-key="number"
              class="column-sortable"
              align="left"
            />
            <v-th
              v-t="'CAMPAIGN_STEP_ROUTING_TARGETS_STATUS'"
              :sort-key="t => t.tStatus.isAcceptingCalls + t.tStatus.blockReason"
              class="column-sortable"
              align="center"
            />
            <th
              v-t="'CAMPAIGN_STEP_ROUTING_TARGETS_ADD'"
              align="center"
            />
          </tr>
        </thead>
        <tbody
          slot="body"
          slot-scope="{ displayData }"
        >
          <tr
            v-for="target in displayData"
            :key="target.id"
          >
            <td align="left">
              <LinkedName
                :href="getHref('dashboard.target.edit', { targetId: target.id, name: target.name })"
                :title="target.name"
              />
            </td>

            <td align="center">
              <i
                v-tooltip.right.hover="$t(target.instructions.callType == 'sip' ? 'TARGETS_TYPE_SIP' : 'TARGETS_TYPE_NUMBER')"
                :class="(target.instructions.callType == 'sip') ? 'typcn typcn-point-of-interest-outline' : 'typcn typcn-phone-outline'"
              />
            </td>
            <td align="left">
              {{ target.instructions.callType === 'number' ? target.instructions.number : target.instructions.sip.number }}
            </td>
            <td align="center">
              <TargetStatus
                :entity="target"
              />
            </td>
            <td align="center">
              <a
                href="javascript:;"
                class="btn btn-list-function typcn typcn-arrow-right-thick"
                @click.prevent="vm.openNewTargetRouteModal(target)"
              />
            </td>
          </tr>
        </tbody>
      </v-table>
      <div class="pagination-min">
        <div class="text-center p-0">
          <smart-pagination
            :current-page.sync="currentPage"
            :total-pages="totalPages"
            :max-page-links="5"
          />
        </div>
      </div>
    </div><!--ending of grid_table_holder-->

    <LoadingStatusDisplay
      v-if="vm.isLoading"
      :loading="true"
    >
      {{ $t('CAMPAIGN_STEP_ROUTING_LOADING_TARGETS') }}
    </LoadingStatusDisplay>
    <div
      v-else-if="!vm.targets.length"
      class="col-xs-12"
    >
      {{ noTargetAvailableMessage }}
    </div>

    <template
      v-if="vm.modal != null"
    >
      <div
        v-if="vm.modal.type === 'new-target'"
        @click="vm.closeModal()"
      >
        <br>
      </div>

      <RoutingNewTargetRoute
        v-if="vm.openNewTargetRouteModal"
        :selected-target="vm.modal.target"
        :route-container="context.routeContainer"
        :route-container-type="context.routeContainerType"
        :current-route="vm.modal.route || {}"
        :is-rpc="vm.modal.target.isRpc || false"
        @cancel="vm.closeModal"
        @create-update="vm.closeModal"
      />
    </template>
  </div>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import { AvailableTargetsViewModel } from '../models/AvailableTargetsViewModel.js';
import sharedMessages from '@/core/locales';
import messages from '../locales';
import LoadingStatusDisplay from '@/core/components/Loader/LoadingStatusDisplay.vue';
import LinkedName from '@/core/components/LinkedName/LinkedName.vue';
import TargetStatus from '@/core/components/Status/Status.vue';
import RoutingPlanTabHeader from './RoutingPlanTabHeader.vue';
import RoutingNewTargetRoute from './RoutingNewTargetRoute.vue';

import {
  $ngStateService,
} from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default defineComponent({
  name: 'AvailableTargets',
  components: {
    RoutingPlanTabHeader,
    LoadingStatusDisplay,
    LinkedName,
    TargetStatus,
    RoutingNewTargetRoute,
  },
  inject: {
    context: {
      from: 'routingPlansContext',
    },
  },
  data() {
    return {
      vm: reactive(new AvailableTargetsViewModel()),
      currentPage: 1,
      totalPages: 0,
      filters: {
        name: {
          value: '',
          keys: ['number', 'phoneNumber', 'displayNumber', 'name', 'campaignName', 'publisherName'],
        },
      },
    };
  },
  computed: {
    noTargetAvailableMessage() {
      if (this.vm.hasAnyTarget) {
        return this.$t('CAMPAIGN_STEP_ROUTING_ALL_TARGETS_ASSIGNED');
      }

      return this.$t('CAMPAIGN_STEP_ROUTING_NONE_TARGETS');
    },
    displayTargets() {
      return (this.vm.targets || []);
    },
  },
  methods: {
    getHref(state, params) {
      return $ngStateService.href(
        state,
        params,
        { absolute: true }
      );
    },
  },
  mounted() {
    this.vm.initialize(this.context);
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
});

</script>
